// src/modules/app-views/invoices/components/InvoiceStatusTag.jsx
// *******************************************************************************
// INVOICE STATUS TAG
// *******************************************************************************
// Displays a tag representing the invoice status (draft, authorized, etc.)
// Uses fiscalService.getStatusColor() for consistent status colors.
// *******************************************************************************

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Tag } from 'antd';
import fiscalService from 'services/fiscalService';
import translateX from 'utils/translateX';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const InvoiceStatusTag = ({ status, data, style = {} }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  // Get status from props or data object
  const invoiceStatus = status || data?.status;

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────
  if (!invoiceStatus) return null;

  const variant = 'solid';
  const color = fiscalService.getStatusColor(invoiceStatus, variant);
  const statusStyle = fiscalService.getStatusStyle(invoiceStatus, variant);

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <Tag color={color} variant={variant} style={{ margin: 0, ...statusStyle, ...style }}>
      {translateX(`invoice_status_${invoiceStatus}`)}
    </Tag>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default InvoiceStatusTag;

// *******************************************************************************
// HELPERS
// *******************************************************************************
